export default function convertHtml(text) {
  return { __html: text };
}
